// language=GraphQL
export const ALL_ACCORDION_BLOCK_ITEMS_QUERY = `query Query {
  accordionBlockItems: cmsAccordionBlockItems {
    id
    title
    content
  }
}`

// language=GraphQL
export const SINGLE_ACCORDION_BLOCK_ITEM_QUERY = `query Query($id: ID!) {
  accordionBlockItem: cmsAccordionBlockItem(id: $id) {
    id
    title
    content
  }
}`

// language=GraphQL
export const CREATE_ACCORDION_BLOCK_ITEM_MUTATION = `
  mutation Mutation($input: CreateCmsAccordionBlockItemInput) {
    accordionBlockItem: createCmsAccordionBlockItem(input: $input) {
      id
      title
      content
    }
  }`

// language=GraphQL
export const UPDATE_ACCORDION_BLOCK_ITEM_MUTATION = `
  mutation Mutation($input: UpdateCmsAccordionBlockItemInput) {
    accordionBlockItem: updateCmsAccordionBlockItem(input: $input) {
      id
      title
      content
    }
  }`

// language=GraphQL
export const DELETE_ACCORDION_BLOCK_ITEM_MUTATION = `
  mutation Mutation($input: DeleteCmsAccordionBlockItemInput) {
    deleteCmsAccordionBlockItem(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION = `
  mutation Mutation($input: DeleteCmsAccordionBlockItemInput) {
    forceDeleteCmsAccordionBlockItem(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ACCORDION_BLOCK_ITEMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsAccordionBlocks: Boolean = false) {
  groupedDependents: cmsAccordionBlockItemDependents(id: $id) {
    cmsAccordionBlocks @include(if: $withCmsAccordionBlocks) {
      id
    }
  }
}`
